import { render, staticRenderFns } from "./listaway.vue?vue&type=template&id=6a715838&scoped=true&"
import script from "./listaway.vue?vue&type=script&lang=js&"
export * from "./listaway.vue?vue&type=script&lang=js&"
import style0 from "./listaway.vue?vue&type=style&index=0&id=6a715838&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a715838",
  null
  
)

export default component.exports